// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vms-icon-loader[data-v-745a5d96]:before{-webkit-animation:spin-data-v-745a5d96 1s linear infinite;animation:spin-data-v-745a5d96 1s linear infinite}@-webkit-keyframes spin-data-v-745a5d96{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spin-data-v-745a5d96{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);
// Exports
module.exports = exports;
